/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["body,html{font-family:Montserrat,sans-serif!important}.lvisib{visibility:hidden}.statdropdown .ui-dropdown{min-width:235px!important}"];
export { styles as styles };

